import { render, staticRenderFns } from "./BaoCanRecord.vue?vue&type=template&id=57acee13&scoped=true"
import script from "./BaoCanRecord.vue?vue&type=script&lang=js"
export * from "./BaoCanRecord.vue?vue&type=script&lang=js"
import style0 from "./BaoCanRecord.vue?vue&type=style&index=0&id=57acee13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57acee13",
  null
  
)

export default component.exports